import { ACTIONS } from "../../common/constants";

const commonConfigDataReducer = function (state = {}, action) {
  switch (action.type) {
    case ACTIONS.SET_COMMON_CONFIG_DATA:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default commonConfigDataReducer;
